
yTos.utils.namespace('yTos.configuration.requireJSConfig.paths');

yTos.configuration.requireJSConfig.paths['ytos.wishlist'] = 'model.wishlist-1.1.0/model.wishlist';
//yTos.configuration.requireJSConfig.paths['ytos.wishlist'] = '/jsrepo/model.wishlist/src/model.wishlist';

yTos.configuration.requireJSConfig.paths['wishlist.loginLayer'] = 'wishlist.loginLayer-1.2.2/wishlist.loginLayer';
//yTos.configuration.requireJSConfig.paths['wishlist.loginLayer'] = '/jsrepo/wishlist.loginLayer/src/wishlist.loginLayer';
